var supara_token = "";
var settings = {
  url: "https://api.backend.gw.t.int.suparagroup.com/gq-connect/auth/token",
  method: "POST",
  timeout: 0,
  headers: {
    "Content-Type": "application/json",
  },
  data: JSON.stringify({
    api_key: "98931F7B-B67D-492C-96F1-A50D66C4DA1B",
    client: "magenest",
  }),
};
var test = [];

$.ajax(settings).done(function (response) {
  supara_token = response.data.token;
});

$(document).ready(function () {
  if ($(window).width() <= 768) {
    $(".page-account .sidebar-main .sidebar-section").click(function () {
      $(this).toggleClass("open-tab");
      $(this).next().slideToggle("slow");
    });
  }
  var modal = $(".central.rte .modal");
  var overlay = $(".central.rte .overlay");
  const closeModal = function () {
    modal.addClass("hidden");
    overlay.addClass("hidden");
  };
  overlay.click(closeModal);
  $(".sidebar-main .cancel-logout-button").click(closeModal);

  function openPopup(popuplink) {
    popuplink.nextAll(".overlay,.modal").removeClass("hidden");
  }
  // open modal event
  $(".tabcontent .request-tax-btn").click(function () {
    openPopup($(this));
  });
  $(".sidebar-main .log-out").click(function () {
    openPopup($(this));
  });
});
function getLastDateOfMonth(year, month) {
  let nextMonth = new Date(year, month, 1);
  let lastDayOfMonth = new Date(nextMonth - 1);
  return lastDayOfMonth.getDate().toString();
}
function getPointList(phone, month = false, year = false) {
  url =
    "https://api.backend.gw.t.int.suparagroup.com/gq-connect/customers/redemptions?mobile=" +
    phone;
  if (month != false) {
    date_from = year + "-" + month + "-01";
    date_to = year + "-" + month + "-" + getLastDateOfMonth(parseInt(year), parseInt(month));
    url = url + "&start_date=" + date_from + "&end_date=" + date_to;
  }
  var ajax_transaction = {
    url: url,
    method: "GET",
    timeout: 0,
    headers: {
      Authorization: "Bearer " + supara_token,
    },
  };

  $.ajax(ajax_transaction).done(function (response) {
    var point_history_list = "";
    for (j = 0; j < response.data.points_histories.length; j++) {
      point = response.data.points_histories[j].points;
      point_history_list =
        point_history_list +
        '<div class="order-line"><div class="order-line-info"><div class="point-history-label">' +
        point.notes +
        '</div><p class="point-change"> -' +
        point.points +
        ' points</p></div><div class="point-history-date">' +
        point.redeemed_time +
        "</div></div>";
    }
    document.getElementById("point-history-list").innerHTML =
      point_history_list;
  });
}
function getLastDateOfMonth(year, month) {
  let nextMonth = new Date(year, month, 1);
  let lastDayOfMonth = new Date(nextMonth - 1);
  return lastDayOfMonth.getDate().toString();
}
function getEarnList(phone, month = false, year = false) {
  url =
    "https://api.backend.gw.t.int.suparagroup.com/gq-connect/customers/points/earn/histories?mobile=" +
    phone;
  if (month != false) {
    date_from = year + "-" + month + "-01";
    date_to = year + "-" + month + "-" + getLastDateOfMonth(parseInt(year), parseInt(month));
    url = url + "&start_date=" + date_from + "&end_date=" + date_to;
  }
  var ajax_transaction = {
    url: url,
    method: "GET",
    timeout: 0,
    headers: {
      Authorization: "Bearer " + supara_token,
    },
  };

  $.ajax(ajax_transaction).done(function (response) {
    var earn_history_list = "";
    if ('data' in response && 'earn_histories' in response.data){
      for (j = 0; j < response.data.earn_histories.length; j++) {
        point = response.data.earn_histories[j];
        if ('reason' in point && point.reason == 'Referral_Points'){
          earn_history_list =
          earn_history_list +
          '<div class="earn-line"><div class="earn-line-info"><div class="point-history-label">' +
          point.promotion_name +
          '</div><p class="point-change"> +' +
          point.points +
          ' points</p></div><div class="point-history-date">' +
          point.issued_on +
          "</div></div>";
        }
      }
    }
    document.getElementById("earn-history-list").innerHTML = earn_history_list;
  });
}
